import React from "react";
import { Grid } from "@mui/material";
import Header from "../components/Header";
import ContactCard from "../components/ContactCard";
import ShareSection from "../components/ShareSection";
import AboutSection from "../components/AboutSection";
import ProductsSection from "../components/ProductsSection";
import GallerySection from "../components/GallerySection";
// import AnalyticsSection from "../components/AnalyticsSection";
import Footer from "../components/Footer";

function Home() {
  return (
    <Grid container direction="column">
      <Header />
      <ContactCard />
      <ShareSection />
      <AboutSection />
      <ProductsSection />
      <GallerySection />
      {/* <AnalyticsSection /> */}
      <Footer />
    </Grid>
  );
}

export default Home;
